<div #contactModal class="modal fade" id="contactModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">Settings</h1>
                <button type="button" #closeButton class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form id="userInfoForm" [formGroup]="userInfoForm" (ngSubmit)="formSubmitted()" role="form" class="m-3 p-2 bg-light border rounded" style="max-width: 95%;">
                <h5>Contact Info</h5>
                <toast-notification #toastNotification></toast-notification>
                <div class="row mb-2">
                    <div class="col">
                        <label for="email" class="col-form-label-sm">Email</label>
                    </div>
                    <div class="col">
                        <input type="text" id="contactemail" name="email" class="form-control-sm" formControlName="email" readonly>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <label for="userName" class="col-form-label-sm">User Name</label>
                    </div>
                    <div class="col">
                        <input type="text" id="userName" name="userName" class="form-control-sm align-middle" formControlName="name" [class.border-danger]="formState.name.invalid">
                        <div *ngIf="formState.name.invalid" class="text-danger">{{formState.name.errorMessage}}</div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <label for="defaultLoc" class="col-form-label-sm">Default Loc</label>
                    </div>
                    <div class="col">
                        <select name="locCode" class="form-select form-select-sm" formControlName="locCode">
                            <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <label for="officeLocation" class="col-form-label-sm">Office Location</label>
                    </div>
                    <div class="col">
                        <select id="officeLocation" name="officeLocation" class="form-select form-select-sm" formControlName="officeLocation">
                            <option *ngFor="let item of officeList" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <label for="phone" class="col-form-label-sm">Phone</label>
                    </div>
                    <div class="col">
                        <input type="text" id="phone" name="phone" formControlName="phone" class="form-control-sm" mask="(000) 000-0000" [class.border-danger]="formState.phone.invalid">
                        <div *ngIf="formState.phone.invalid" class="text-danger">{{formState.phone.errorMessage}}</div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <label for="fax" class="col-form-label-sm">Fax</label>
                    </div>
                    <div class="col">
                        <input type="text" id="fax" name="fax" formControlName="fax" class="form-control-sm" mask="(000) 000-0000" [class.border-danger]="formState.fax.invalid">
                        <div *ngIf="formState.fax.invalid" class="text-danger">{{formState.fax.errorMessage}}</div>
                    </div>
                </div>
                <div class="row form-check">
                    <div class="col">
                        <input type="checkbox" class="form-check-input" id="useDefaultFilters" name="useDefaultFilters" [checked]="contactInfo.useDefaultFilters" (click)="toggleUseDefaultFilters()">
                        <label class="form-check-label form-label">
                            Use Default Filters
                        </label>
                    </div>
                </div>
                <div style="height: 25px;"></div>
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <button type="button" class="btn btn-sm btn-secondary mx-1" [hidden]="!isFormChanged" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-sm btn-primary mx-1" [disabled]="!isFormChanged" (click)="saveContactInfo()">Save</button>
                    </div>
                </div>
            </form>

            @if (+contactInfo.accessLevel >= 10 && contactInfo.role !== scaleOperatorRoleId) {
                <form role="form" class="m-3 p-2 bg-light border rounded" style="max-width: 95%;">
                    <h5>Admin</h5>
                    <div class="row align-items-center">
                        <div class="col">
                            <h6 class="mb-0 ps-2">Application Configuration</h6>
                        </div>
                        <div class="col d-flex align-items-end justify-content-end">
                            <a (click)="openAdminConfig()" class="btn btn-sm btn-primary me-1 ps-3 pe-3" style="cursor: pointer;">Open</a>
                        </div>
                    </div>
                </form>
            }
        </div>
    </div>
</div>
